import { Quill } from 'react-quill';

/*
 * mentionBlot.ts
 * Registers the Quill blot which renders a tagged colleague inside the
 * editor as an @name chip. The user hash and name are stored as data
 * attributes on the span, so the backend can detect who is tagged and
 * the saved html renders the name in blue.
 */

// The data of a tagged user stored on a mention
export interface MentionValue {
    userHash: string;
    name: string;
}

// The user which can be tagged, as returned by the backend
export interface MentionUserType {
    user_hash: string;
    full_name: string;
}

// Tracks whether the blot is registered on the shared Quill instance
let mentionBlotRegistered = false;

// Registers the mention blot once
export const registerMentionBlot = () => {
    if (mentionBlotRegistered) return;
    mentionBlotRegistered = true;

    // Get the embed blot the mention extends
    const Embed: any = Quill.import('blots/embed');

    // Inline embed which renders a tagged colleague as an @name chip
    class MentionBlot extends Embed {
        static blotName = 'mention';
        static tagName = 'span';
        static className = 'mention';

        // Create the mention node with the user data attributes
        static create(value: MentionValue) {
            const node = super.create(value) as HTMLElement;
            node.setAttribute('data-user-hash', value.userHash);
            node.setAttribute('data-user-name', value.name);
            node.textContent = `@${value.name}`;
            return node;
        }

        // Read the user data back from an existing mention node
        static value(node: HTMLElement): MentionValue {
            return {
                userHash: node.getAttribute('data-user-hash') || '',
                name: node.getAttribute('data-user-name') || '',
            };
        }
    }

    Quill.register('formats/mention', MentionBlot);
};
